import React, { useState } from 'react';
import BlogLink from '../../BlogLink';
import { Container, Input, Label, Result, Text } from '../../styles';
import Base from '../Base';
import ListTable from './ListTable';



function Treasure() {


  // 変更する
  // ---------------------------------------------
  // 2023.3.22
  // 1040,31200(sum,cost)

  // a_coach,b_coach,energy,spi_medal,ticket,point,coin,spirit,excavated_coin
  const getRate = [0.02702702702702703, 0.036036036036036036, 0.13513513513513514, 11.711711711711711, 0.17117117117117117, 57.65765765765766, 238.73873873873873, 0.018018018018018018, 67.56756756756756]; //獲得数/掘削数

  const shovelPerEngrgyInit = 6; //スコップ/1エナジー


  // 表示設定
  // ---------------------------------------------
  // const [digits, setDigits] = useState(0);
  const digits = 0;
  const [energy, setEnergy] = useState(250);
  const [shovelPerEngrgy, setShovelPerEngrgy] = useState(shovelPerEngrgyInit);

  // ---------------------------------------------

  // 確認する
  // 初期設定
  // ---------------------------------------------
  const needShovel = 3;
  const timesPerEngrgy = shovelPerEngrgy / needShovel; //1エナジーあたり何回抽選できるか

  const returnRate = getRate[2] * timesPerEngrgy


  // ---------------------------------------------

  //   集計
  const getRatePerEnergy = [];
  for (let i = 0; i < getRate.length; i++) {
    getRatePerEnergy[i] = getRate[i] * timesPerEngrgy //1エナジーあたりi等が何回当たるか
  }


  //   実質消費エナジー
  const realEnergy = 1 - returnRate;

  //   消費エナジー変更
  const handleEnergyChange = (event) => {
    setEnergy(event.target.value);
  };

  //   桁数変更
  // const handleDigitsChange = (event) => {
  //   if (event.target.value >= 0) {
  //     var dig = event.target.value;
  //   } else {
  //     var dig = 0;
  //   }
  //   setDigits(dig);
  // };


  const calculateItem = () => {
    const getItemPerRealEnergy = [];
    const getItemExpected = [];
    for (let i = 0; i < getRate.length; i++) {
      // getItemPerRealEnergy[i] = getItem[i] / realEnergy;
      getItemPerRealEnergy[i] = getRatePerEnergy[i] / realEnergy; //後で修正

      getItemExpected[i] = ((getItemPerRealEnergy[i] * energy)).toFixed(digits);
    }
    console.log(getItemPerRealEnergy)

    return getItemExpected
  }

  // a_coach,b_coach,energy,spi_medal,ticket,point,coin,spirit,excavated_coin

  const getItemExpected = calculateItem()

  const itemExpectedList = [
    { name: 'Aランク特訓コーチ', result: getItemExpected[0] },
    { name: 'Bランク特訓コーチ', result: getItemExpected[1] },
    { name: 'スピメダル', result: getItemExpected[3] },
    { name: '試練チケット', result: getItemExpected[4] },
    { name: 'スカウトP', result: getItemExpected[5] },
    { name: 'コイン', result: getItemExpected[6] },
    { name: '覚醒魂', result: getItemExpected[7] },
  ];

  return (
    <>
      <Base body={
        <Container>
          <h1>プロスピトレジャー</h1>
          <Label>
            <Text>消費エナジー：</Text>
            <Input type="number" value={energy} onChange={handleEnergyChange} />
          </Label>

          < div >
            <h2>計算結果</h2>
            <ListTable list={itemExpectedList} />
          </div >
          <Result>
            <Text>エナジー還元率:{returnRate.toFixed(3)}</Text>
          </Result>
          <div>
            <p>{energy}エナジー消費した時に得られるアイテム数の期待値がResultに表示されます。</p>
          </div>
          <BlogLink link={"https://www.sakusaku27.com/"} />
        </Container>

      } title="プロスピトレジャー" />
    </>
  );
}

export default Treasure;
